<template>
  <section class="sign-page background">
    <div class="container">
      <div class="window-ctr">
        <div class="window">
          <div class="tabs">
            <div
              class="tab"
              :class="{'active': isSignInPage}"
              @click="switchTo('sign-in')"
            >Logowanie</div>
            <div
              class="tab"
              :class="{'active': isSignUpPage}"
              @click="switchTo('sign-up')"
            >Rejestracja</div>
          </div>
          <div class="content">
            <form
              class="sign-in"
              v-show="isSignInPage"
              :class="{'validate': validationOn}"
              @submit.prevent="signIn"
            >
              <div class="error-box" v-show="signInErrorBox">
                <div class="icon-ctr">
                  <i class="fas fa-exclamation-circle"></i>
                </div>
                <div>
                  <span
                    class="error-info"
                  >Próba logowania nie powiodła się. Upewnij się, że dane są poprawne.</span>
                </div>
              </div>
              <label for="sign-in-email">E-mail</label>
              <input
                v-model="signInData.email"
                type="email"
                id="sign-in-email"
                title="Podaj swój e-mail"
                placeholder="Podaj swój e-mail"
                required
              >
              <label for="sign-in-password">Hasło</label>
              <input
                v-model="signInData.password"
                type="password"
                id="sign-in-password"
                title="Wpisz hasło"
                placeholder="Wpisz hasło"
                minlength="6"
                required
              >
              <div class="button-ctr">
                <button type="submit" class="action" title="Zaloguj się" @click="validateForm">
                  <i class="fas fa-sign-in-alt"></i>Zaloguj się
                </button>
              </div>
            </form>
            <form
              class="sign-up"
              v-show="isSignUpPage"
              :class="{'validate': validationOn}"
              @submit.prevent="signUp"
            >
              <div class="error-box" v-show="signUpErrorBox">
                <div class="icon-ctr">
                  <i class="fas fa-exclamation-circle"></i>
                </div>
                <div>
                  <span class="error-info">
                    Rejestracja nie powiodła się, być może takie konto już istnieje.
                    Sprawdź poprawność danych.
                  </span>
                </div>
              </div>
              <label for="sign-up-email">E-mail</label>
              <input
                v-model="signUpData.email"
                type="email"
                id="sign-up-email"
                title="Podaj swój e-mail"
                placeholder="Podaj swój e-mail"
                required
              >
              <label for="sign-up-password">Hasło</label>
              <input
                v-model="signUpData.password"
                type="password"
                id="sign-up-password"
                title="Wpisz hasło"
                placeholder="Wpisz hasło"
                minlength="6"
                required
              >
              <label for="sign-up-password2">Powtórz hasło</label>
              <input
                v-model="signUpData.password2"
                type="password"
                id="sign-up-password2"
                title="Powtórz hasło"
                placeholder="Powtórz hasło"
                minlength="6"
                required
              >
              <div>
                <TermsCheckbox
                  v-model="signUpData.confirmed"
                  :class="{'invalid': validationOn && !signUpData.confirmed}"
                />
              </div>
              <div class="button-ctr">
                <button type="submit" class="action" title="Zarejestruj się" @click="validateForm">
                  <i class="fas fa-user-plus"></i>Zarejestruj się
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import TermsCheckbox from '../controls/TermsCheckbox.vue';

import updatePageTitle from '../helpers/updatePageTitle';

const signInString = 'sign-in';
const signUpString = 'sign-up';

export default {
  name: 'SignPage',
  components: {
    TermsCheckbox,
  },
  data() {
    return {
      tab: signInString,
      validationOn: false,
      signInData: {
        email: '',
        password: '',
      },
      signUpData: {
        email: '',
        password: '',
        password2: '',
        confirmed: false,
      },
      signInErrorBox: false,
      signUpErrorBox: false,
    };
  },
  computed: {
    isSignInPage() {
      return this.tab === signInString;
    },
    isSignUpPage() {
      return this.tab === signUpString;
    },
  },
  created() {
    updatePageTitle('Logowanie i rejestracja');
  },
  beforeRouteUpdate(to, from, next) {
    updatePageTitle('Logowanie i rejestracja');

    next();
  },
  methods: {
    switchTo(newTab) {
      this.tab = newTab;
    },
    validateForm() {
      this.validationOn = true;
    },
    signIn() {
      const params = {
        ...this.signInData,
        onSuccess: () => {
          this.signInErrorBox = false;
          this.$router.push('/');
        },
        onFailure: () => {
          this.signInErrorBox = true;
        },
      };

      this.$store.dispatch('user/signIn', params);
    },
    signUp() {
      // wymagana akceptacja regulaminu
      if (!this.signUpData.confirmed) return;

      if (this.signUpData.password !== this.signUpData.password2) {
        // eslint-disable-next-line no-alert
        alert('Hasła się różnią!');
        return;
      }

      const params = {
        ...this.signUpData,
        onSuccess: () => {
          this.signUpErrorBox = false;
          this.$router.push('/');
        },
        onFailure: () => {
          this.signUpErrorBox = true;
        },
      };

      this.$store.dispatch('user/signUp', params);
    },
  },
};
</script>

<style scoped>
.sign-page {
  min-height: 600px;
}

.window-ctr {
  padding-top: 80px;
  display: flex;
  justify-content: center;
}

.window {
  display: flex;
  flex-flow: column nowrap;
  width: 400px;
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 0.7);
  box-shadow: 0 0 15px 10px rgba(0, 0, 0, 0.3);
}

.window .tabs {
  display: flex;
  flex-flow: row nowrap;
}

.window .tabs .tab {
  width: 50%;
  font-size: 22px;
  text-align: center;
  padding: 15px 0;
  cursor: pointer;
  color: #999;
  border-bottom: 2px solid #999;
}

.window .tabs .tab.active {
  color: var(--color-main);
  border-color: var(--color-main);
  background-color: rgba(63, 81, 181, 0.2);
}

.window .tabs .tab:hover {
  background-color: var(--color-main);
  color: #fff;
  border-color: var(--color-main);
}

.window .tabs .tab:first-of-type {
  border-top-left-radius: 8px;
}

.window .tabs .tab:last-of-type {
  border-top-right-radius: 8px;
}

.window .content {
  padding: 20px 20px 10px;
}

.window .content form {
  display: flex;
  flex-flow: column wrap;
}

.window .content form label {
  font-weight: 300;
}

.window .content form input {
  margin: 5px 0 10px;
  border: 1px solid #999;
  border-radius: 4px;
  background: none;
  padding: 10px 20px;
}

.window .content form input:focus {
  border-color: var(--color-main);
}

.window .content form input:invalid {
  box-shadow: none;
}

.window .content form.validate input:invalid {
  border-color: #ff5f5f;
}

.window .content form .button-ctr {
  display: flex;
  justify-content: center;
  margin: 10px 0;
}

.window .content .error-box {
  display: flex;
  flex-flow: row nowrap;
  margin-bottom: 20px;
  padding: 5px 10px;
  border: 1px solid #ff1f1f;
  border-radius: 4px;
  color: #ff1f1f;
}

.window .content .error-box .icon-ctr {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
}

.window .content .error-box .error-info {
  font-size: 14px;
}
</style>
